const openMobileMenu = () => {
  $('.nav-trigger').on('click', function(event) {
    $(this).toggleClass('is-active');

    $('.header__navigation').toggleClass('is-open');

    event.preventDefault();
  });
}

openMobileMenu();
